var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeeknessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5151",
    "data-name": "Group 5151",
    transform: "translate(-1010 -647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    transform: "translate(1013 650)",
    fill: "#f9b33a",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 30.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(1010.785 648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15042",
    "data-name": "Path 15042",
    d: "M157.869,19.121l2.7-1.815A13.571,13.571,0,0,1,168.138,15h7.977m-6.195,15.917,1.045,4.5a4.031,4.031,0,0,1-3.1,4.858h0l-2.377-5.019a9.385,9.385,0,0,0-3.2-3.74l-4.416-3.007",
    transform: "translate(-132.427 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15043",
    "data-name": "Path 15043",
    d: "M15.215,15.114h7.6a1.87,1.87,0,0,1,1.87,1.87v12.1a1.87,1.87,0,0,1-1.87,1.87h-7.6ZM30.863,42.833,29.49,44.206m8.9-1.373,1.373,1.373m-5.137.959v1.941M20.614,26.949h0M34.07,30.82H45.223a1.963,1.963,0,0,0,1.963-1.963h0a1.963,1.963,0,0,0-1.963-1.963",
    transform: "translate(0 -0.106)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15044",
    "data-name": "Path 15044",
    d: "M457.9,137.373h-.671a1.985,1.985,0,0,0,1.985-1.984h0a1.984,1.984,0,0,0-1.985-1.984",
    transform: "translate(-412.699 -110.555)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15045",
    "data-name": "Path 15045",
    d: "M446.968,78.228h-.738a1.985,1.985,0,0,0,1.984-1.984h0a1.984,1.984,0,0,0-1.984-1.984",
    transform: "translate(-402.437 -55.282)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15046",
    "data-name": "Path 15046",
    d: "M431.3,19.082H430.23a1.985,1.985,0,0,0,1.984-1.984h0a1.984,1.984,0,0,0-1.984-1.984",
    transform: "translate(-387.511 -0.105)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeknessIcon);
export default __webpack_public_path__ + "static/media/weekness-icon.250fb96f87b31eebf1e19839bce27996.svg";
export { ForwardRef as ReactComponent };